import { render } from "./carouselRemHandy.vue?vue&type=template&id=4c145c0f"
import script from "./carouselRemHandy.vue?vue&type=script&lang=js"
export * from "./carouselRemHandy.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Git-Local\\afm.git - Kopie\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__